import { createAction } from '@reduxjs/toolkit';

export const segmentMiddlewareReady = createAction(
    'store/SEGMENT_MIDDLEWARE::READY',
);

export const facebookMiddlewareReady = createAction(
    'store/FACEBOOK_MIDDLEWARE::READY',
);
